import React, {

    useState,

    useEffect,

    useCallback

} from "react";
import Swal from "sweetalert2";
import "./DailyPaymentTransaction.css";



import {

    Table,

    Card,

    Input,

    AutoComplete,

    Button,

    Tag,

    Typography,

    Spin,

    Empty,

    Row,

    Col,

    Divider

} from "antd";



import {

    SearchOutlined,

    ReloadOutlined,

    FilePdfOutlined

} from "@ant-design/icons";



import {

    PDFDownloadLink

} from "@react-pdf/renderer";



import api from "../../api/api";



import DailyPaymentTransactionPDF

from "./DailyPaymentTransactionPDF";



import {

    useAcademicYear

} from "../../AcademicYearContext";





const {

    Title,

    Text

} = Typography;









const DailyPaymentTransaction = () => {









/*
|--------------------------------------------------------------------------
| Academic Year Context
|--------------------------------------------------------------------------
*/


const {

    selectedYear

} = useAcademicYear();











/*
|--------------------------------------------------------------------------
| States
|--------------------------------------------------------------------------
*/



// Main transaction data

const [

    transactions,

    setTransactions

] = useState([]);





// Selected student transaction data

const [

    studentTransactions,

    setStudentTransactions

] = useState([]);





// Student autocomplete list

const [

    students,

    setStudents

] = useState([]);





// Selected student

const [

    selectedStudent,

    setSelectedStudent

] = useState(null);





// Student search text

const [

    studentSearch,

    setStudentSearch

] = useState("");





// General search

const [

    searchText,

    setSearchText

] = useState("");





// Loading

const [

    loading,

    setLoading

] = useState(false);





// Backend pagination

const [

    pagination,

    setPagination

] = useState({

    current:1,

    pageSize:20

});





// Total backend records

const [

    totalRecords,

    setTotalRecords

] = useState(0);











/*
|--------------------------------------------------------------------------
| Fetch Daily Transactions
|--------------------------------------------------------------------------
*/



const fetchTransactions =

useCallback(



async()=>{



    if(!selectedYear){

        return;

    }







    try{



        setLoading(true);







        const response =

        await api.get(

            "/daily-payment-transactions/",

            {

                params:{


                    academic_year:

                    selectedYear.id,


                    daily:true,


                    page:

                    pagination.current,


                    page_size:

                    pagination.pageSize,


                    search:

                    searchText


                }

            }

        );







        const result =

        response.data;







  const dailyResults = result.results || [];


setTransactions(
    dailyResults
);


setTotalRecords(
    result.count || 0
);


// No transaction today alert
if(dailyResults.length === 0){

    Swal.fire({

        icon: "info",

        title: "No Transaction Today",

        text:
        "There are no daily payment transactions recorded for today.",

        confirmButtonColor:
        "#f97316",

        background:
        "#18181b",

        color:
        "#ffffff"

    });

}


    }

    catch(error){



        console.error(

            "Daily transaction loading error:",

            error

        );





        setTransactions([]);




    }

    finally{



        setLoading(false);



    }





},



[

    selectedYear,

    pagination.current,

    pagination.pageSize,

    searchText

]



);














/*
|--------------------------------------------------------------------------
| Fetch Selected Student Transactions
|--------------------------------------------------------------------------
*/



const fetchStudentTransactions =

useCallback(



async(studentId)=>{





    if(

        !studentId ||

        !selectedYear

    ){


        setStudentTransactions([]);


        return;


    }







    try{



        setLoading(true);







        const response =

        await api.get(

            "/daily-payment-transactions/",

            {

                params:{


                    academic_year:

                    selectedYear.id,


                    student:

                    studentId,


                    page:1,


                    page_size:100


                }

            }

        );







        setStudentTransactions(

            response.data?.results || []

        );







    }

    catch(error){



        console.error(

            "Student transaction loading error:",

            error

        );





        setStudentTransactions([]);




    }

    finally{



        setLoading(false);



    }






},



[

    selectedYear

]



);












/*
|--------------------------------------------------------------------------
| Hooks
|--------------------------------------------------------------------------
*/



useEffect(()=>{


    fetchTransactions();



},



[

    fetchTransactions

]



);











/*
|--------------------------------------------------------------------------
| Student Search
|--------------------------------------------------------------------------
*/



const fetchPaidStudents =

useCallback(



async(value)=>{





    setStudentSearch(

        value

    );







    if(!value){



        setStudents([]);



        return;



    }







    try{





        const response =

        await api.get(

            "/daily-payment-transactions/",

            {

                params:{


                    academic_year:

                    selectedYear?.id,


                    daily:true,


                    search:value,


                    page_size:50


                }

            }

        );







        const data =

        response.data?.results || [];








        const uniqueStudents =

        Array.from(



            new Map(

                data.map(item=>[


                    item.student_id,


                    {


                        id:

                        item.student_id,


                        full_name:

                        item.student_name


                    }



                ])

            )

            .values()



        );








        setStudents(

            uniqueStudents

        );








    }

    catch(error){



        console.error(

            "Student search error:",

            error

        );





        setStudents([]);




    }







},



[

    selectedYear

]



);













/*
|--------------------------------------------------------------------------
| Student Selection
|--------------------------------------------------------------------------
*/



const handleStudentSelect =

(student)=>{





    setSelectedStudent(

        student

    );






    setStudentSearch(

        student.full_name

    );







    setPagination({

        current:1,

        pageSize:20

    });







    fetchStudentTransactions(

        student.id

    );





};


 
/*
|--------------------------------------------------------------------------
| Table Pagination Handler
|--------------------------------------------------------------------------
*/


const handleTableChange =

(
    page,
    pageSize
)=>{


    setPagination({

        current:page,

        pageSize:pageSize

    });


};











/*
|--------------------------------------------------------------------------
| Search Handler
|--------------------------------------------------------------------------
*/


const handleSearch =

(value)=>{


    setSearchText(

        value

    );



    setPagination({

        current:1,

        pageSize:20

    });


};













/*
|--------------------------------------------------------------------------
| Table Columns
|--------------------------------------------------------------------------
*/


const columns = [



{

title:"ID",

dataIndex:"id",

key:"id",

width:60,

responsive:[

    "md"

]

},





{

title:"Student",

dataIndex:"student_name",

key:"student_name",

width:180,

render:(value)=>(

<Text strong>

{value}

</Text>

)

},







{

title:"Fee Type",

dataIndex:"fee_type",

key:"fee_type",

width:160,

ellipsis:true

},







{

title:"Category",

dataIndex:"payment_category",

key:"payment_category",

width:130,


render:(value)=>(



<Tag


style={{


background:

value === "School Fee"

?

"#84cc16"

:

"#f97316",



color:"#111827",


border:"none",


fontWeight:700,


borderRadius:20


}}



>



{value}



</Tag>



)

},









{

title:"Amount",

dataIndex:"amount_paid",

key:"amount_paid",

width:120,


render:(value)=>(


<Text

strong

style={{

color:"#f97316"

}}

>


${value}



</Text>


)

},







{

title:"Balance",

dataIndex:"balance",

key:"balance",

width:110

},







{

title:"Payer",

dataIndex:"payer_name",

key:"payer_name",

width:150,

ellipsis:true,

responsive:[

"lg"

]

},









{

title:"Cashier",

dataIndex:"created_by",

key:"created_by",

width:130,

responsive:[

"lg"

]

},









{

title:"Date",

dataIndex:"created_at",

key:"created_at",

width:120

},









{

title:"Year",

dataIndex:"academic_year",

key:"academic_year",

width:120,

responsive:[

"xl"

]

}



];













/*
|--------------------------------------------------------------------------
| Mobile Card Helper
|--------------------------------------------------------------------------
*/


const MobileTransactionCard =

({

item

})=>(



<Card


className="mobile-payment-card"



>



<Row gutter={[8,8]}>


<Col span={24}>



<Text strong>

{item.student_name}

</Text>



</Col>





<Col span={12}>



<Text type="secondary">

Fee

</Text>



<br/>



{item.fee_type}



</Col>







<Col span={12}>



<Text type="secondary">

Amount

</Text>



<br/>



<Text strong style={{color:"#f97316"}}>


${item.amount_paid}


</Text>



</Col>







<Col span={12}>



<Text type="secondary">

Category

</Text>



<br/>



<Tag>


{item.payment_category}


</Tag>



</Col>







<Col span={12}>



<Text type="secondary">

Date

</Text>



<br/>



{item.date}



</Col>







<Col span={24}>



<Text type="secondary">

Cashier

</Text>



<br/>



{item.created_by || "-"}



</Col>





</Row>




</Card>



);















/*
|--------------------------------------------------------------------------
| Component Return
|--------------------------------------------------------------------------
*/


return (

<div

className="daily-payment-wrapper"

>






<Card

className="daily-payment-card"

bordered={false}

>









<Row

justify="space-between"

align="middle"

gutter={[16,16]}

>



<Col

xs={24}

md={16}

>



<Title

level={3}

style={{

margin:0,

color:"#ffffff"

}}

>


Daily Payment Transactions


</Title>





<Text

style={{

color:"#d1d5db"

}}

>


Student payment history and daily financial records


</Text>



</Col>







<Col

xs={24}

md={8}

>



<Tag

className="active-year-tag"

>



Active Year:

{" "}

{selectedYear?.name || "No Year"}



</Tag>



</Col>



</Row>









<Divider

className="dark-divider"

/>









<Row

gutter={[12,12]}

>



<Col

xs={24}

md={8}

>



<Input

size="large"

placeholder="Search payment..."

prefix={

<SearchOutlined/>

}

value={searchText}

onChange={

(e)=>

handleSearch(

e.target.value

)

}

/>



</Col>







<Col

xs={24}

md={5}

>



<Button

block

size="large"

icon={<ReloadOutlined/>}

onClick={fetchTransactions}

className="refresh-payment-btn"

>


Refresh


</Button>



</Col>









<Col

xs={24}

md={5}

>



<PDFDownloadLink



document={



<DailyPaymentTransactionPDF



transactions={transactions}


/>


}



fileName="Daily_Payment_Record.pdf"



>



{

({loading})=>(



<Button

block

size="large"

disabled={loading}

icon={<FilePdfOutlined/>}

className="daily-pdf-btn"

>



Daily PDF


</Button>



)



}



</PDFDownloadLink>



</Col>







</Row>









<Divider

className="dark-divider"

/>

{
loading ?


<div className="payment-loading">


<Spin size="large"/>


</div>



:

transactions.length === 0 ?



<div className="payment-empty">


<Empty

description="No payment records found"

/>



</div>



:



<>


<div className="desktop-payment-table">


<Table



rowKey="id"



columns={columns}



dataSource={transactions}



pagination={{

current:

pagination.current,


pageSize:

pagination.pageSize,


total:

totalRecords,


showSizeChanger:true,


pageSizeOptions:[

20,

50,

100

]

}}



onChange={handleTableChange}



tableLayout="fixed"



/>



</div>








<div className="mobile-payment-list">



{

transactions.map(item=>(


<MobileTransactionCard

key={item.id}

item={item}


/>


))

}



</div>



</>



}







</Card>





</div>

);
// ============================================================
// Component End
// ============================================================


};


export default DailyPaymentTransaction;